import {handleActions} from 'redux-actions';

import {
  CLEAR_WEB_AVATAR_OVERRIDE,
  CLEAR_WEB_PROFILE_IMAGE_OVERRIDES,
  SET_WEB_AFTER_OVERRIDE,
  SET_WEB_AVATAR_OVERRIDE,
  SET_WEB_BEFORE_OVERRIDE,
  WebImageOverrideState,
} from '/redux/action/coach.action';
import {withPayload} from '/util/reducer.util';

const initialState: WebImageOverrideState = {
  avatar: null,
  before: null,
  after: null,
};

export default handleActions<WebImageOverrideState, any>(
  {
    [SET_WEB_AVATAR_OVERRIDE]: withPayload(
      (state: WebImageOverrideState, avatar: string | null) => ({
        ...state,
        avatar,
      }),
    ),
    [SET_WEB_BEFORE_OVERRIDE]: withPayload(
      (state: WebImageOverrideState, before: string | null) => ({
        ...state,
        before,
      }),
    ),
    [SET_WEB_AFTER_OVERRIDE]: withPayload(
      (state: WebImageOverrideState, after: string | null) => ({
        ...state,
        after,
      }),
    ),
    [CLEAR_WEB_AVATAR_OVERRIDE]: state => ({
      ...state,
      avatar: null,
    }),
    [CLEAR_WEB_PROFILE_IMAGE_OVERRIDES]: () => initialState,
  },
  initialState,
);
